<script>
  import { getCollectionFromStorefront, activeCollectionTab, setActiveTab, viewAllBgColour, viewAllButton } from './stores/activeCollection.js';

  export let collectionData;
  let mql = window.matchMedia('(max-width: 1025px)');

  window.addEventListener('resize', () => mql = window.matchMedia('(max-width: 1025px)'))

  function handleViewAll(handle) {
    let activeCollectionIndex = collectionData.findIndex( collection => collection.handle == handle);
    let collectionViewAllBackground = collectionData[activeCollectionIndex].viewAllBackground.replaceAll('"','').trim();
    let collectionViewAllButton = collectionData[activeCollectionIndex].viewAllButton.replaceAll('"','').trim();

    viewAllBgColour.update(bgColour => bgColour = collectionViewAllBackground);
    viewAllButton.update(buttonColour => buttonColour = collectionViewAllButton);
  }
</script>

<ul class="flex mb-5">
  <li class="text-brand-black mr-9 last:mr-0">
    <button
      class="h4 flex flex-col text-left"
      on:click={() => handleViewAll(collectionData[0].handle)}
    >
    <span class="t-subheader">{collectionData[0].subtitle}</span>
    {collectionData[0].title}
    </button>
  </li>
</ul>
